export const selectContentType = state => state.login.contentType;

export const selectIsVerified = state => state.login.isVerified;

export const selectVerificationInProgress = state => state.login.verificationInProgress;
